import axios from 'axios';
import { API_CORE_URL } from '../constantes/constantes';

/**
 * Obtiene los datos del carrusel de categorías de una liga.
 *
 * @param {Object} params - Parámetros para construir la URL.
 * @param {string} params.id - ID de la liga que llega como prop desde el componente.
 * @returns {Promise<{ data: any, statusCode: number }>} Objeto con los datos o estado del error.
 */
export async function getCarrouselCategory({ id, type, version: country }) {
  try {
    const url = `${API_CORE_URL}teams/${type}/${id}`;

    const { data, status } = await axios.get(url, {
      timeout: 25000,
      headers: {
        'Accept': 'application/json, text/plain, */*'
      },
      params: {
        ...(country === 'us' && {country})
      },
    });

    return { data, statusCode: status };
  } catch (error) {
    console.error("Error en getCarrouselCategory:", error.message || error);
    const statusCode = error.response?.status || 500;
    return { statusCode, data: [] };
  }
}
